/*
 * @Author: Chris 
 * @Date: 2022-07-28 10:58:52 
 * @Last Modified by: Chris
 * @Last Modified time: 2022-10-11 11:46:45
 */
 
<template>
  <div class="PAGE_OUTSTYLE">
    <el-card class="UserManagement_card">
      <div class="card_header">
        <div class="left-btn">
          <!-- <div class="header_rightadd" @click="InvitationCompany(0)">邀请维保单位</div> -->
          <!-- <div class="header_rightadd" @click="InvitationCompany(1)">邀请使用单位</div> -->
          <div class="header_rightadd" @click="InvitationCompany(2)">邀请监管单位</div>
          <div class="header_rightadd" @click="InvitationCompany(3)">邀请保险单位</div>
        </div>
        <div class="header_leftSearch">
          <el-input
            placeholder="请输入公司名称"
            @input="searchname"
            v-model="searchInput"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
      </div>
      <div class="card_body">
        <el-table
          v-loading="tableLoading"
          :header-cell-style="{ background: '#EBEBEB', color: '#333' }"
          :data="tableData"
          @cell-dblclick="this.$dblClickCopy"
          style="width: 100%"
        >
          <el-table-column type="index" label="序号" align="center" width="100">
          </el-table-column>
          <el-table-column label="公司名称" prop="companyName">
          </el-table-column>
          <el-table-column label="公司类型" prop="companyType">
          </el-table-column>
          <el-table-column prop="nickName" label="主管理员"> </el-table-column>
          <el-table-column prop="phoneNumber" label="手机号"> </el-table-column>
          <el-table-column prop="createTime" label="创建时间">
          </el-table-column>
          <el-table-column prop="userName" label="公司状态">
            <template slot-scope="scope">
              <div v-if="scope.row.status == 'enable'" class="tableState_green">
                已启用
              </div>
              <div
                v-if="scope.row.status == 'stopUsing'"
                class="tableState_red"
              >
                已停用
              </div>
            </template>
          </el-table-column>
          <el-table-column width="100" label="操作">
            <template slot-scope="scope">
              <el-link
                class="table_link"
                target="_blank"
                @click="ModifyCompanyInformationM(scope.row)"
              >
                <i class="el-icon-edit"></i>编辑
              </el-link>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页器 -->

        <div class="pagination">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="size"
            :current-page="current"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :total="tableDataTotal"
          >
          </el-pagination>
        </div>
      </div>
    </el-card>

    <!-- 列表编辑框 -->

    <ModifyCompanyInformationDrawer
      :choosecompanyMsg="choosecompanyMsg"
      @getUserListMethods="getUserListMethods"
    ></ModifyCompanyInformationDrawer>
  </div>
</template>

<script>
import {
  getUserList,
  createInvateLink
} from "../../api/api";
import ModifyCompanyInformationDrawer from "../userManagement/components/companyInformation";
import Headerimg from "../../assets/IMG/menu/userheader.png";
export default {
  name: "UserManagement",
  components: {
    ModifyCompanyInformationDrawer,
  },
  data() {
    return {
      tableLoading: false,
      Headerimg: Headerimg,
      tableDataTotal: 0, //列表总数
      size: 10, //页面条数
      current: 1, //当前页
      searchInput: "", //搜索输入框
      url: "", //邀请链接
      choosecompanyMsg: null, //选择的公司信息
      tableData: [],
    };
  },
  created() {},
  mounted() {
    this.getUserListMethods();
  },
  methods: {
    /**
     * 头部搜索框
     * */

    searchname(e) {
      this.searchInput = e;
      this.getUserListMethods();
    },

    /**
     * 获取公司列表
     * */

    async getUserListMethods() {
      this.tableLoading = true;
      let params = {
        size: this.size,
        current: this.current,
        companyName: this.searchInput,
      };
      let res = await getUserList(params).catch(() => {
        this.tableLoading = false;
      });
      this.tableLoading = false;
      if (res.code === 200) {
        this.tableDataTotal = res.data.total;
        this.tableData = res.data.content;
      }
    },

    /**
     * 修改公司信息
     * 打开右侧抽屉
     * */

    ModifyCompanyInformationM(e) {
      this.choosecompanyMsg = e;
      this.$store.commit("SET_Drawer_UserManagement_Edit", true);
    },

    /**
     * * * * * * * * * * * * * * *
     * *
     * * 邀请链接相关方法
     * *
     * * * * * * * * * * * * * * *
     * */
    // 邀请维保单位
    InvitationCompany(type) {
      createInvateLink({
        companyType: type || 0
      }).then((res) => {
        if (res.code == 200) {
          this.url =
            process.env.VUE_APP_WEBURL +
            "/registration/1/" +
            encodeURIComponent(res.data);
          this.copyLinkM();
        }
      });
    },

    /**
     * 点击复制
     * */

    copyLinkM() {
      let this_ = this;
      var save = function (e) {
        e.clipboardData.setData("text/plain", this_.url);
        e.preventDefault();
      };
      document.addEventListener("copy", save);
      document.execCommand("copy");
      document.removeEventListener("copy", save);
      this.$notify.success({
        title: "成功",
        message: "生成邀请链接，已复制到剪切板！",
      });
    },

    /**
     * * * * * * * * * * * * * * *
     * *
     * * 分页器相关
     * *
     * * * * * * * * * * * * * * *
     * */

    /**
     * 分页器条数改变
     * */

    handleSizeChange(e) {
      this.size = e;
      this.getUserListMethods();
    },

    /**
     * 分页器页数改变
     * */

    handleCurrentChange(e) {
      this.current = e;
      this.getUserListMethods();
    },
  },
};
</script>

<style lang="scss" scoped>
.UserManagement_card :deep(.el-link.el-link--danger) {
  color: #b7282d;
}
.UserManagement_card :deep(.el-link.el-link--success) {
  color: #27c57c;
}
.UserManagement_card :deep(.el-link.el-link--default) {
  color: #333333;
}

.UserManagement_card {
  // height: calc(100% - 0.625rem);

  .card_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 3.125rem;
    .header_leftSearch {
      width: 15.4375rem;
    }
    .left-btn {
      display: flex;
      align-items: center;
    }
    .header_rightadd {
      width: 5.75rem;
      height: 2rem;
      background: #b7282d;
      border-radius: 0.25rem;
      color: #ffffff;
      font-size: 0.75rem;
      display: flex;
      align-items: center;
      justify-content: center;
      user-select: none;
      cursor: pointer;
      margin-right: 10px;
    }
  }
  .card_body {
    margin-top: 10px;
    height: calc(100vh - 216px);
    overflow-y: auto;

    .com_name {
      display: flex;
      align-items: center;
      .com_logo {
        width: 3.625rem;
        height: 3.625rem;
        border-radius: 0.25rem;
        margin-right: 0.75rem;
      }
    }

    .tableState_red {
      border: 0.0625rem solid #f84638;
      border-radius: 0.9375rem;
      color: #f84638;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 3.5rem;
      height: 1.3125rem;
    }

    .tableState_green {
      border: 0.0625rem solid #27c57c;
      border-radius: 0.9375rem;
      color: #27c57c;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 3.5rem;
      height: 1.3125rem;
    }

    .table_link {
      margin-right: 1rem;
      .ICON_ {
        width: 0.8125rem;
        height: 0.8125rem;
      }
    }
    .table_link :nth-last-child(1) {
      margin-right: 0rem;
    }
  }

  .drawer_header {
    width: 100%;
    border-top: 0.125rem solid #eeeeee;
  }
}
</style>